module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-user"
  }, [_c('div', {
    staticClass: "container-select-subsidiary"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('p', {
    staticClass: "label-title"
  }, [_vm._v("Seleccione las Sucursales")]), _vm._v(" "), _c('div', {
    staticClass: "container-user"
  }, [_c('v-checkbox', {
    staticClass: "block-checkbox",
    attrs: {
      "label": "Seleccionar todos",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.selectAll('subsidiaries', _vm.subsidiaries, _vm.allSubsidiary)
      }
    },
    model: {
      value: (_vm.allSubsidiary),
      callback: function($$v) {
        _vm.allSubsidiary = $$v
      },
      expression: "allSubsidiary"
    }
  }), _vm._v(" "), _vm._l((_vm.subsidiaries), function(subsidiary, indexSub) {
    return _c('v-checkbox', {
      key: indexSub,
      staticClass: "block-checkbox",
      attrs: {
        "hide-details": "",
        "label": subsidiary.sucursal_name
      },
      model: {
        value: (subsidiary.isSelected),
        callback: function($$v) {
          subsidiary.isSelected = $$v
        },
        expression: "subsidiary.isSelected"
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "container-btn"
  }, [_c('v-btn', {
    staticClass: "btn-save btn-save-form",
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateSubsidiary($event)
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn__content btn-save-form",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close-modal')
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f60485a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/users/modal-user.vue
// module id = 1626
// module chunks = 29